import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import ProductStockList from "./ProductStockList";
import ProductTraceabilityList from "./ProductTraceabilityList";
import ProductImg from "./ProductImg";
import ProductStockAdjustment from "./ProductStockAdjustment";
import ProductStockTransfer from "./ProductStockTransfer";
import HearingAidsData from "./HearingAidsData";
import LensesData from "./LensesData";
import ContactLensesData from "./ContactLensesData";
import LiquidsData from "./LiquidsData";
import FramesData from "./FramesData";
import VariousData from "./VariousData";
import SunglassesData from "./SunglassesData";
import ButtonIconH from "./ButtonIconH";
import CheckBox from "./CheckBox";
import moment from "moment";
import {
  selectedOptic,
  userData,
  areObjectsEqual,
  selectProductName,
  svgIcons,
} from "../js/utils";
import { post } from "../js/post";
import "../css/ProductPanel.css";
import LoadingScreen from "./LoadingScreen";
import GoDexLabelPopup from "./GoDexLabelPopup";

export default function ProductPanel(props) {
  const [productImg, setProductImg] = useState(null);
  const [productImgName, setProductImgName] = useState("");
  const [productStock, setProductStock] = useState(0);
  const [stockList, setStockList] = useState([]);
  const [traceabilityList, setTraceabilityList] = useState([]);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [currentProductFixed, setCurrentProductFixed] = useState(null);
  const [productCode, setProductCode] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(true);
  const brand =
    props.brandList && props.brandList.length === 1 ? props.brandList[0] : "";
  const [advancedDataChanges, setAdvancedDataChanges] = useState(false);
  const [toggleCode, setToggleCode] = useState(false);
  const [toggleStock, setToggleStock] = useState(false);
  const [productFamily, setProductFamily] = useState(props.productFamily);
  const [currentSupplier, setCurrentSupplier] = useState(null);
  const [goDexLabelPopup, setGoDexLabelPopup] = useState(false);
  const productRef = useRef();

  // console.log("stockList: ", stockList, selectedOptic);

  function selectProductData() {
    const product = {
      0: (
        <HearingAidsData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          ref={productRef}
        />
      ),
      1: (
        <LensesData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          ref={productRef}
        />
      ),
      2: (
        <ContactLensesData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          createPopupQuestion={props.createPopupQuestion}
          removePopupQuestion={props.removePopupQuestion}
          ref={productRef}
        />
      ),
      3: (
        <LiquidsData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          ref={productRef}
        />
      ),
      4: (
        <FramesData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          ref={productRef}
        />
      ),
      5: (
        <VariousData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          ref={productRef}
        />
      ),
      6: (
        <SunglassesData
          code={productCode}
          supplierCode={props.supplierCode}
          brand={brand}
          handleProduct={(prod, prodF) => {
            setCurrentProduct(prod);
            setCurrentProductFixed(prodF);
          }}
          onSearchByCode={setProductCode}
          handleProductNotFound={setProductNotFoundMessage}
          handleSearch={(f) => checkCurrentProductChanges(f)}
          registerFromDeliveryNote={props.registerFromDeliveryNote}
          ref={productRef}
        />
      ),
    };
    return product[productFamily];
  }

  function setProductNotFoundMessage(code) {
    props.createPopupQuestion(
      `No existe ningún producto con el código ${code}.`,
      props.removePopupQuestion,
      null,
      "Entendido",
    );
  }

  const checkActiveOfferPrice = () => {
    const { pvpOferta, fechaOfertaInicio, fechaOfertaFin } = currentProduct;
    if (!pvpOferta || !fechaOfertaInicio || !fechaOfertaFin) return "";
    const now = new Date();
    if (now >= new Date(fechaOfertaInicio) && now <= new Date(fechaOfertaFin))
      return pvpOferta;
    return "";
  };

  const getFamilyIcon = () => {
    const iconObj = {
      0: "/images/preferenciaAudifonos-white.svg",
      1: "/images/preferenciaGafasGraduadas-white.svg",
      2: "/images/preferenciaLentillas-white.svg",
      3: "/images/preferenciaLiquido-white.svg",
      4: "/images/accommodative-white.svg",
      5: "/images/preferenciaVarios-white.svg",
      6: "/images/preferenciaGafasDeSol-white.svg",
    };
    return iconObj[productFamily] || "";
  };

  async function getProductImg() {
    const response = await post("ObtenerImagenProducto.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      codigo: productCode,
      idOptica: selectedOptic.id,
    });
    setProductImg(response.img);
    // console.log(
    // "OBTENIENDO IMAGEN PRODUCTO: ",
    // {
    // token: userData.token,
    // codigo: productCode,
    // idOptica: selectedOptic.id,
    // },
    // response,
    // );
  }

  async function getSupplier() {
    const response = await post("ObtenerProveedor.php", {
      token: userData.token,
      idProveedor: props.supplierCode,
    });
    setCurrentSupplier(response);
  }

  async function getStock() {
    const response = await post("ObtenerStockProducto.php", {
      token: userData.token,
      codigo: productCode,
      idOptica: -1,
    });
    response.map((e) => {
      if (e.nombreOptica === selectedOptic.nombre) {
        setProductStock(parseInt(e.stock));
      }
    });
    setStockList(response);
  }

  async function getTraceability() {
    const response = await post("ObtenerTrazabilidadProducto.php", {
      token: userData.token,
      codigo: productCode,
    });
    setTraceabilityList(response);
  }

  function validateProduct() {
    const { idProveedor, marca, modelo, nombreComercial, producto } =
      currentProduct;

    const family = Number(productFamily);

    switch (family) {
      case 0: // Audifonos
      case 4: // Monturas
      case 6: // Gafas de sol
        return idProveedor !== -1 && marca !== "" && modelo !== "";
      case 1: // Lentes oftálmicas
      case 2: // Lentillas
      case 3: // Líquidos
        return idProveedor !== -1 && marca !== "" && nombreComercial !== "";
      case 5: // Varios
        return idProveedor !== -1 && marca !== "" && producto !== "";
      default:
        return false;
    }
  }

  async function saveProduct(endpoint, allOptics = false) {
    const response = await post(endpoint, {
      token: userData.token,
      idOptica: allOptics ? -1 : selectedOptic.id,
      ...currentProduct,
    });
    setCurrentProductFixed(currentProduct);
    setAdvancedDataChanges(false);
    return response;
  }

  async function checkDuplicateProduct() {
    const endpoint = {
      0: "ComprobarDuplicadoAudifono.php",
      1: "ComprobarDuplicadoLenteOftalmica.php",
      2: "ComprobarDuplicadoLenteContacto.php",
      3: "ComprobarDuplicadoLiquido.php",
      4: "ComprobarDuplicadoMontura.php",
      5: "ComprobarDuplicadoVarios.php",
      6: "ComprobarDuplicadoGafasSol.php",
    }[productFamily];

    const body = {
      0: {
        modelo: currentProduct.modelo,
      },
      1: {
        nombreComercial: currentProduct.nombreComercial,
      },
      2: {
        nombreComercial: currentProduct.nombreComercial,
      },
      3: {
        nombreComercial: currentProduct.nombreComercial,
        capacidad: currentProduct.capacidad,
      },
      4: {
        modelo: currentProduct.modelo,
        color: currentProduct.color,
        calibre: currentProduct.calibre,
        puente: currentProduct.puente,
        varilla: currentProduct.varilla,
      },
      5: {
        producto: currentProduct.producto,
        subtipo: currentProduct.subtipo,
      },
      6: {
        modelo: currentProduct.modelo,
        color: currentProduct.color,
        colorCristal: currentProduct.colorCristal,
        calibre: currentProduct.calibre,
        puente: currentProduct.puente,
        varilla: currentProduct.varilla,
      },
    }[productFamily];
    const response = await post(endpoint, {
      token: userData.token,
      codigoOPTIWIN: currentProduct.codigoOPTIWIN,
      codigoEANUPC: currentProduct.codigoEANUPC,
      marca: currentProduct.marca,
      ...body,
    });
    return response;
  }

  async function deleteProduct() {
    await post("EliminarProducto.php", {
      token: userData.token,
      codigo: productCode,
      idUsuario: userData.id,
    });
  }

  async function saveToCurrentOptic(endpoint) {
    const respCode = await saveProduct(endpoint);
    await saveProductImage(respCode.codigoOPTIWIN);
  }

  async function saveToAllOptics(endpoint) {
    const respCode = await saveProduct(endpoint, true);
    await saveProductImage(respCode.codigoOPTIWIN);
  }

  async function validateAndSaveProduct(popup = true, onClose = () => {}) {
    if (!validateProduct()) {
      props.createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) antes de guardar la ficha del producto.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }

    if (checkSpecialPrice()) {
      props.createPopupQuestion(
        `El pvp especial no puede ser mayor que el pvp del producto.`,
        props.removePopupQuestion,
        null,
        "Entendido",
      );
      return;
    }

    const endpoint = {
      0: "EditarAudifono.php",
      1: "EditarLenteOftalmica.php",
      2: "EditarLenteContacto.php",
      3: "EditarLiquido.php",
      4: "EditarMontura.php",
      5: "EditarVarios.php",
      6: "EditarGafasSol.php",
    }[productFamily];

    if (popup) {
      if (advancedDataChanges) {
        props.createPopupQuestion(
          `¿Desea aplicar los cambios a todas las ópticas o solo a la actual?`,
          async () => {
            props.removePopupQuestion();
            const response = await checkDuplicateProduct();
            if (response.length === 0) {
              await saveToAllOptics(endpoint);
              props.createPopupQuestion(
                "Producto guardado satisfactoriamente.",
                () => {
                  props.removePopupQuestion();
                  onClose();
                },
                null,
                "Aceptar",
              );
            } else {
              props.createPopupQuestion(
                showDuplicateProducts(response),
                props.removePopupQuestion,
                null,
                "Entendido",
              );
            }
          },
          async () => {
            props.removePopupQuestion();
            const response = await checkDuplicateProduct();

            if (response.length === 0) {
              await saveToCurrentOptic(endpoint);
              props.createPopupQuestion(
                "Producto guardado satisfactoriamente.",
                () => {
                  props.removePopupQuestion();
                  onClose();
                },
                null,
                "Aceptar",
              );
            } else {
              props.createPopupQuestion(
                showDuplicateProducts(response),
                props.removePopupQuestion,
                null,
                "Entendido",
              );
            }
          },
          "Todas",
          "Actual",
        );
      } else {
        const response = await checkDuplicateProduct();

        if (response.length === 0) {
          await saveToCurrentOptic(endpoint);
          props.createPopupQuestion(
            "Producto guardado satisfactoriamente.",
            () => {
              onClose();
              props.removePopupQuestion();
            },
            null,
            "Aceptar",
          );
        } else {
          props.createPopupQuestion(
            showDuplicateProducts(response),
            props.removePopupQuestion,
            null,
            "Entendido",
          );
        }
      }
    } else {
      const response = await checkDuplicateProduct();

      if (response.length === 0) {
        const res = await saveProduct(endpoint);
        await saveProductImage(res.codigoOPTIWIN);
        props.createPopupQuestion(
          `Producto creado satisfactoriamente (id: ${res.id}).`,
          async () => {
            await getProduct(res.codigoOPTIWIN);
            props.removePopupQuestion();
          },
          null,
          "Aceptar",
        );
      } else {
        props.createPopupQuestion(
          showDuplicateProducts(response),
          props.removePopupQuestion,
          null,
          "Entendido",
        );
      }
    }
  }

  async function getProduct(productCode) {
    const endpoint = {
      0: "ObtenerAudifono.php",
      1: "ObtenerLenteOftalmica.php",
      2: "ObtenerLenteContacto.php",
      3: "ObtenerLiquido.php",
      4: "ObtenerMontura.php",
      5: "ObtenerVarios.php",
      6: "ObtenerGafasSol.php",
    }[productFamily];

    const response = await post(endpoint, {
      token: userData.token,
      codigo: productCode,
      tipoCodigo: 0,
      idOptica: selectedOptic.id,
    });
    setCurrentProduct(response);
    setCurrentProductFixed(response);
    setProductCode(response.codigoOPTIWIN);
  }

  async function saveProductImage(productCode) {
    if ((productImg === "" || !productImg) && productImgName === "") return;
    const response = await post("SubirImagenProducto.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      codigo: productCode,
      nombreFichero: productImgName,
      img: productImg || "",
      idAgente: userData.id,
    });
    if (response.error) {
      props.createPopupQuestion(
        response.error,
        () => {
          props.removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  async function deleteProductImage() {
    await post("EliminarImagenProducto.php", {
      token: userData.token,
      idOptica: selectedOptic.id,
      codigo: productCode,
    });
    setProductImg(null);
  }

  async function getStockAndTraceability() {
    await getStock();
    await getTraceability();
  }

  function checkSpecialPrice() {
    return (
      parseFloat(currentProduct.pvpEspecial) > parseFloat(currentProduct.pvp)
    );
  }

  function checkAdvancedDataChanges() {
    if (productCode === -1 || !currentProduct || !currentProductFixed) return;

    const fieldsToCompare = [
      ["fechaLimite"],
      ["pvp", parseFloat],
      ["iva", parseInt],
      ["pvpRecomendado", parseFloat],
      ["fechaOfertaInicio"],
      ["fechaOfertaFin"],
      ["pvpOferta", parseFloat],
      ["comision", parseInt],
      ["unidadesPvpEspecial", parseInt],
      ["dtoMaximo", parseInt],
      ["pvpEspecial", parseFloat],
      ["stockMinimo", parseInt],
      ["sinControlStock"],
      ["descatalogado"],
    ];

    const hasChanges = fieldsToCompare.some(([key, parser]) => {
      const valA = currentProduct[key];
      const valB = currentProductFixed[key];
      return (parser ? parser(valA) : valA) !== (parser ? parser(valB) : valB);
    });

    setAdvancedDataChanges(hasChanges);
  }

  async function checkCurrentProductChanges(func = () => {}) {
    const { codigoOPTIWIN: code1, ...currentProductAux } = currentProduct;
    const { codigoOPTIWIN: code2, ...currentProductFixedAux } =
      currentProductFixed;
    if (!areObjectsEqual(currentProductAux, currentProductFixedAux)) {
      props.createPopupQuestion(
        `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de buscar el producto?`,
        async () => {
          props.removePopupQuestion();
          await validateAndSaveProduct();
          func();
        },
        async () => {
          props.removePopupQuestion();
          func();
        },
        "Sí",
        "No",
      );
    } else {
      func();
    }
  }

  const handleCreate = (condition) => {
    productRef.current?.triggerAction(condition);
  };

  const focusPropery = () => {
    if (!productRef.current || !currentProduct) return;

    const familyFieldMap = {
      0: ["marca", "modelo"],
      1: ["marca", "nombreComercial"],
      2: ["marca", "nombreComercial"],
      3: ["marca", "nombreComercial"],
      4: ["marca", "modelo"],
      5: ["marca", "producto"],
      6: ["marca", "modelo"],
    };

    const focusCodeMap = {
      marca: 504,
      modelo: 505,
      nombreComercial: 505,
      producto: 505,
    };

    const fields = familyFieldMap[productFamily];
    if (!fields) return;

    for (const field of fields) {
      if (currentProduct[field] === "") {
        productRef.current.triggerAction(focusCodeMap[field]);
        break;
      }
    }
  };

  const handleAddNewProductDeliveryNote = async (condition) => {
    if (props.registerFromDeliveryNote) {
      const respAdd = await props.onDBProducts(currentProduct, productFamily);
      if (respAdd.idProductoAlbaran) {
        switch (condition) {
          case 0:
            handleCreate(condition);
            break;
          case 1:
            handleCreate(condition);
            break;
          case 2:
            props.onClose();
          default:
            break;
        }
      }

      return;
    }
  };

  async function createNewProduct(condition) {
    if (!validateProduct()) {
      props.createPopupQuestion(
        `Por favor, rellene los campos obligatorios (*) antes de guardar la ficha del producto.`,
        () => {
          props.removePopupQuestion();
          focusPropery();
        },
        null,
        "Entendido",
      );
      return;
    }
    const endpoint = {
      0: "CrearAudifono.php",
      1: "CrearLenteOftalmica.php",
      2: "CrearLenteContacto.php",
      3: "CrearLiquido.php",
      4: "CrearMontura.php",
      5: "CrearVarios.php",
      6: "CrearGafasSol.php",
    }[productFamily];

    const response = await checkDuplicateProduct();
    if (response.length === 0) {
      // Aquí devolvemos de alguna manera el producto creado si estamos en albarán.
      if (props.registerFromDeliveryNote) {
        await handleAddNewProductDeliveryNote(condition);
        return;
      }
      // Si estamos en almacén, continuamos con el resto de código.
      const respCreate = await post(endpoint, {
        token: userData.token,
        idOptica: selectedOptic.id,
        ...currentProduct,
      });

      if (respCreate) {
        setCurrentProductFixed(currentProduct);
        switch (condition) {
          case 0:
            handleCreate(condition);
            break;
          case 1:
            handleCreate(condition);
            break;
          case 2:
          default:
            break;
        }
      }
      props.createPopupQuestion(
        `Producto creado satisfactoriamente (código OPTIWIN: ${respCreate.codigoOPTIWIN}).`,
        () => {
          props.removePopupQuestion();
          if (condition === 2) {
            props.onClose();
          }
        },
        null,
        "Aceptar",
      );
    } else {
      props.createPopupQuestion(
        showDuplicateProducts(response),
        props.removePopupQuestion,
        null,
        "Entendido",
      );
    }
  }

  function showDuplicateProducts(products) {
    const message = (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 20,
        }}
      >
        <span>
          Atención. Se han encontrado los siguientes productos duplicados.
        </span>
        <DataTable
          columns={[
            {
              name: "En almacén",
              selector: (row) =>
                row.codigoOPTIWIN
                  ? `${row.codigoOPTIWIN} - ${row.descripcion}`
                  : row.descripcion,
              sortable: true,
            },
            {
              name: "En creación/edición",
              selector: (row) =>
                row.codigoDuplicado
                  ? `${row.codigoDuplicado} - ${row.descripcionDuplicado}`
                  : row.descripcionDuplicado,
              sortable: true,
            },
          ]}
          data={products}
          className="custom-datatable"
          noDataComponent="No hay productos duplicados."
        />
      </div>
    );
    return message;
  }

  useEffect(() => {
    setProductFamily(props.productFamily);
  }, []);

  useEffect(() => {
    if (props.productCode === -1) {
      setLoadingProduct(false);
    }
    setProductCode(props.productCode);
  }, [props.productCode]);

  useEffect(() => {
    if (productCode && productCode !== -1) {
      async function getFullProduct() {
        await getProductImg();
        await getStock();
        await getTraceability();
        setLoadingProduct(false);
      }
      getFullProduct();
    }
  }, [productCode]);

  useEffect(() => {
    checkAdvancedDataChanges();
  }, [currentProduct]);

  useEffect(() => {
    if (props.supplierCode !== -1) getSupplier();
  }, [props.supplierCode]);

  return (
    <div className="external-window-bg">
      <div
        className="external-window external-window-suppliers"
        style={productCode === -1 ? { height: "auto", width: "50%" } : {}}
      >
        <div className="external-window-header">
          {(productCode !== -1 || productFamily === -1) && (
            <button
              className="popup-action-icon close-icon"
              onClick={async () => {
                if (productFamily === -1) {
                  props.onClose();
                  return;
                }
                if (!areObjectsEqual(currentProduct, currentProductFixed)) {
                  props.createPopupQuestion(
                    `Existen cambios sin guardar en la ficha actual. ¿Desea guardar los cambios antes de salir?`,
                    async () => {
                      props.removePopupQuestion();
                      await validateAndSaveProduct(true, () => {
                        props.onClose();
                      });
                    },
                    async () => {
                      props.removePopupQuestion();
                      props.onClose();
                    },
                    "Sí",
                    "No",
                  );
                } else {
                  props.onClose();
                }
              }}
            >
              <img
                src="/images/close-white.svg"
                loading="lazy"
                alt="Icon"
              ></img>
            </button>
          )}
          <span
            className="popup-screen-header-title"
            style={{ display: "flex", alignItems: "center", gap: 8 }}
          >
            <img style={{ height: 15 }} src={getFamilyIcon()}></img>
            {selectProductName(productFamily)}
            {productCode === -1
              ? props.registerFromDeliveryNote
                ? " - Nuevo producto"
                : " - Nuevo producto sin compra"
              : ""}
          </span>
        </div>
        {goDexLabelPopup && (
          <GoDexLabelPopup
            product={{
              codigoOPTIWIN: currentProduct.codigoOPTIWIN,
              pvp: currentProduct.pvp,
              pvpOferta: checkActiveOfferPrice(),
              pvpRecomendado: currentProduct.pvpRecomendado,
              etiquetado: currentProduct.etiquetado,
              stock: stockList.find(
                (op) => op.nombreOptica === selectedOptic.nombre,
              ).stock,
            }}
            createPopupQuestion={props.createPopupQuestion}
            removePopupQuestion={props.removePopupQuestion}
            onClose={() => {
              setGoDexLabelPopup(false);
            }}
          />
        )}
        {loadingProduct && (
          <LoadingScreen message="Cargando datos del producto..."></LoadingScreen>
        )}
        {!loadingProduct && (
          <div
            style={{
              width: "100%",
              gap: 10,
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              paddingRight: "2px",
            }}
          >
            {productCode !== -1 && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 10,
                }}
              >
                {currentProduct && productCode !== -1 && (
                  <div className="container-panel" style={{ width: "50%" }}>
                    <div
                      className="opt-table-content grid-5"
                      id="product-content-grid"
                    >
                      <div className="cell cell-label cell-start-content">
                        Fecha de alta
                      </div>
                      <div className="cell">
                        <input
                          type="datetime-local"
                          max="9999-12-31T23:59"
                          disabled={true}
                          step={1}
                          className="input-field input-cell"
                          value={currentProduct.fechaAlta}
                        ></input>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Fecha última compra
                      </div>
                      <div className="cell">
                        <input
                          type="datetime-local"
                          max="9999-12-31T23:59"
                          disabled={true}
                          step={1}
                          className="input-field input-cell"
                          value={currentProduct.fechaUltimaCompra}
                        ></input>
                      </div>
                      <div className="cell cell-label cell-start-content">
                        Fecha límite
                      </div>
                      <div className="cell">
                        <input
                          type="datetime-local"
                          max="9999-12-31T23:59"
                          step={1}
                          className="input-field input-cell"
                          value={currentProduct.fechaLimite}
                          onChange={(e) => {
                            const value = e.target.value;
                            setCurrentProduct((prev) => ({
                              ...prev,
                              fechaLimite:
                                value === ""
                                  ? ""
                                  : moment(value).format("YYYY-MM-DD HH:mm:ss"),
                            }));
                          }}
                        ></input>
                      </div>
                      <div className="cell"></div>
                      <div className="cell cell-label cell-start-content">
                        Fecha última venta
                      </div>
                      <div className="cell">
                        <input
                          type="datetime-local"
                          max="9999-12-31T23:59"
                          disabled={true}
                          step={1}
                          className="input-field input-cell"
                          value={currentProduct.fechaUltimaVenta}
                        ></input>
                      </div>
                    </div>
                  </div>
                )}
                {productCode !== -1 && (
                  <div
                    className="container-panel popup-screen-box"
                    style={{
                      width: "50%",
                    }}
                  >
                    <ButtonIconH
                      text="Código"
                      icon={svgIcons.code}
                      onClick={() => {
                        setGoDexLabelPopup(true);
                      }}
                    ></ButtonIconH>
                    <ButtonIconH
                      text="Guardar"
                      icon={svgIcons.save}
                      onClick={validateAndSaveProduct}
                    ></ButtonIconH>
                    <ButtonIconH
                      text="Eliminar"
                      icon={svgIcons.remove}
                      onClick={() => {
                        props.createPopupQuestion(
                          `¿Desea eliminar el producto?`,
                          async () => {
                            props.onClose();
                            await deleteProduct();
                            props.removePopupQuestion();
                          },
                          props.removePopupQuestion,
                          "Sí",
                          "No",
                        );
                      }}
                    ></ButtonIconH>
                  </div>
                )}
              </div>
            )}
            <div className="product-info">
              {productFamily === -1 && (
                <div className="container-panel" style={{ width: "100%" }}>
                  <div className="opt-table-title">
                    Seleccione familia de producto
                  </div>
                  {currentSupplier && (
                    <div
                      style={{
                        marginTop: 20,
                        display: "flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                      }}
                    >
                      <ButtonIconH
                        text="Audífonos"
                        icon={svgIcons.hearingAids}
                        disabled={!currentSupplier.audifonos}
                        onClick={() => {
                          setProductFamily(0);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Lentes"
                        icon={svgIcons.lens}
                        disabled={!currentSupplier.cristales}
                        onClick={() => {
                          setProductFamily(1);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="L. Contacto"
                        icon={svgIcons.contactLenses}
                        disabled={!currentSupplier.lentillas}
                        onClick={() => {
                          setProductFamily(2);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Líquidos"
                        icon={svgIcons.liquids}
                        disabled={!currentSupplier.liquidos}
                        onClick={() => {
                          setProductFamily(3);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Monturas"
                        icon={svgIcons.frames}
                        disabled={!currentSupplier.monturas}
                        onClick={() => {
                          setProductFamily(4);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Varios"
                        icon={svgIcons.various}
                        disabled={!currentSupplier.varios}
                        onClick={() => {
                          setProductFamily(5);
                        }}
                      ></ButtonIconH>
                      <ButtonIconH
                        text="Sol"
                        icon={svgIcons.sunglasses}
                        disabled={!currentSupplier.gafas}
                        onClick={() => {
                          setProductFamily(6);
                        }}
                      ></ButtonIconH>
                    </div>
                  )}
                </div>
              )}
              {productFamily !== -1 && (
                <div
                  className="container-panel product-info-col"
                  style={{ width: productCode !== -1 ? "60%" : "100%" }}
                >
                  <div className="opt-table-title">
                    Datos de producto
                    {currentProduct && currentProduct.descatalogado && (
                      <span className="discountinued-tag">(Descatalogado)</span>
                    )}
                  </div>
                  {productCode && selectProductData()}
                </div>
              )}
              {productCode !== -1 && (
                <div
                  className="container-panel product-info-col"
                  style={{ width: "20%" }}
                >
                  <div className="opt-table-title">
                    Stock de producto (
                    {stockList.reduce(
                      (acc, e) => acc + (parseFloat(e.stock) || 0),
                      0,
                    )}
                    )
                  </div>
                  <ProductStockList stockList={stockList} />
                </div>
              )}
              {productCode !== -1 && (
                <div className="product-info-col" style={{ width: "20%" }}>
                  <div className="container-panel">
                    <div className="opt-table-title">Imagen de producto</div>
                    <ProductImg
                      img={productImg}
                      onUpload={(img, name) => {
                        setProductImg(img);
                        setProductImgName(name);
                      }}
                      onDelete={() => {
                        props.createPopupQuestion(
                          `¿Desea eliminar la imagen del producto?`,
                          async () => {
                            await deleteProductImage();
                            props.removePopupQuestion();
                          },
                          props.removePopupQuestion,
                          "Sí",
                          "No",
                        );
                      }}
                    />
                  </div>
                  <div className="container-panel">
                    <div>
                      <div className="opt-table-title">Ajuste de stock</div>
                      <ProductStockAdjustment
                        productCode={productCode}
                        stock={productStock}
                        onAccept={getStockAndTraceability}
                        createPopupQuestion={props.createPopupQuestion}
                        removePopupQuestion={props.removePopupQuestion}
                      />
                    </div>
                    <div>
                      <div className="opt-table-title">Traspaso de stock</div>
                      <ProductStockTransfer
                        productCode={productCode}
                        stock={productStock}
                        onAccept={getStockAndTraceability}
                        createPopupQuestion={props.createPopupQuestion}
                        removePopupQuestion={props.removePopupQuestion}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
            {productCode !== -1 && (
              <div className="product-info">
                <ProductTraceabilityList traceabilityList={traceabilityList} />
              </div>
            )}
            {productCode === -1 && productFamily !== -1 && (
              <div className="container-panel">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={`opt-table-content grid-${
                      props.registerFromDeliveryNote ? "3" : "5"
                    }`}
                    id={`product-content-buttons-${
                      props.registerFromDeliveryNote ? "delivery-note" : "store"
                    }`}
                  >
                    {!props.registerFromDeliveryNote && (
                      <>
                        <div className="data-field cell-start-content">
                          <span className="label">Imprimir código</span>
                        </div>
                        <div className="cell cell-start-content">
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setToggleCode(!toggleCode);
                            }}
                          >
                            <CheckBox
                              tabIndex={535}
                              active={toggleCode}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="cell">
                      <ButtonIconH
                        text="Guardar y nuevo"
                        customW={170}
                        onClick={async () => {
                          await createNewProduct(0);
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell">
                      <ButtonIconH
                        text="Guardar y salir"
                        customW={170}
                        onClick={async () => {
                          await createNewProduct(2);
                        }}
                      ></ButtonIconH>
                    </div>
                    {!props.registerFromDeliveryNote && (
                      <>
                        <div className="data-field cell-start-content">
                          <span className="label">Imprimir stock</span>
                        </div>
                        <div className="cell cell-start-content">
                          <div
                            className="data-field c-pointer"
                            onClick={() => {
                              setToggleStock(!toggleStock);
                            }}
                          >
                            <CheckBox
                              tabIndex={535}
                              active={toggleStock}
                              onClick={() => {}}
                            ></CheckBox>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="cell">
                      <ButtonIconH
                        text="Guardar y duplicar"
                        customW={170}
                        onClick={async () => {
                          await createNewProduct(1);
                        }}
                      ></ButtonIconH>
                    </div>
                    <div className="cell"></div>
                    <div className="cell">
                      <ButtonIconH
                        text="Salir"
                        customW={170}
                        onClick={() => {
                          if (
                            !areObjectsEqual(currentProduct, {
                              ...currentProductFixed,
                              iva: currentProduct.iva,
                            })
                          ) {
                            props.createPopupQuestion(
                              `Existen cambios sin guardar en la ficha de producto actual. ¿Desea volver y continuar con la creación de la ficha de producto?`,
                              async () => {
                                props.removePopupQuestion();
                              },
                              async () => {
                                props.removePopupQuestion();
                                props.onClose();
                              },
                              "Sí",
                              "No",
                            );
                          } else {
                            props.onClose();
                          }
                        }}
                      ></ButtonIconH>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
